import React from 'react'
import { Section } from '../../components/Section'
import { SectionContentHeader } from '../../components/SectionContentHeader'
import { SiteLink } from '../../app-types'
import { ExternalGigproLinks, INTRASITE_LINKS } from '../../constants'

const links: SiteLink[] = [
  {
    id: 'mara-cta-post-a-shift',
    label: 'POST A SHIFT',
    variant: 'contained',
    page: null,
    pageSection: null,
    article: null,
    externalHref: ExternalGigproLinks.login,
  },
  {
    id: 'mara-cta-get-started',
    label: 'GET STARTED WITH QWICK',
    variant: 'contained',
    page: null,
    pageSection: null,
    article: null,
    internalHref: INTRASITE_LINKS.home.pagePath,
  },
]

export const SectionContentInstanceMaraCta: React.FunctionComponent = () => (
  <Section
    padding={100}
    cloudinaryBackground={{
      publicId: 'photography/mara-gradient-bg',
      alt: 'Mara gradient banner',
    }}
  >
    <SectionContentHeader
      id="mara-cta"
      align="center"
      subheading={null}
      heading="Hospitality moves fast. So does Mara."
      description={{
        description:
          'Experience the AI-powered assistant that keeps shifts filled and businesses running.',
      }}
      links={links}
      showAppStoreLinks={false}
      eyebrowColor={(theme) => theme.palette.primary.main}
    />
  </Section>
)
